<template>
<div class=""  style="padding:0 20px;">

   <el-form ref="formBasic" :model="$centro.profile.row" @submit.native.prevent="onSubmit" :rules="rules" label-width="180px" style="margin-top:20px;">

      
      <div class="row pad" style="margin-top:20px;">

        <h3>BENVENUTO NEL NETWORK INNSIN!</h3>
<br />
Per completare la richiesta di adesione al progetto e poter compilare le schede pazienti, si prega di seguire le indicazioni sotto riportate.

<br /><br />
         Ogni Centro aderente al Network INNSIN è proprietario dei propri dati e la SIN, promotrice del progetto, è proprietaria dei dati aggregati anonimizzati di tutti i centri che aderiscono al Network e li utilizzerà per scopi epidemiologici nei rapporti con le Istituzioni (nazionali e regionali) e con aziende nel solo interesse della SIN e dei suoi soci.
         <br />
         Ai fini dell’esecuzione del Progetto, ogni Centro, in quanto Titolare dei dati, è tenuto a:
<ol>
<li>
stipulare un accordo di collaborazione con SIN
</li>
<!--
  <li>
nominare Biomedia srl responsabile esterno del trattamento dei dati per le finalità di supervisione del Progetto
</li>
-->
<li>
nominare TerAs MM srl, società operante nel settore tecnico-informatico, amministratore di sistema 
</li>
</ol>

A tal fine si prega di scaricare, compilare, firmare con firma elettronica qualificata* (digitale) e ricaricare i due documenti (in formato p7m)
<br />
I documenti, firmati digitalmente dal Primario che abbia i relativi poteri di firma, verranno poi controfirmati digitalmente da SIN e Teras.
<br />
* per informazioni sulla firma elettronica qualificata <a href="https://www.agid.gov.it/index.php/it/piattaforme/firma-elettronica-qualificata" target="_blank">cliccare qui</a> 
<br />
Qualora il Referente non disponga della firma elettronica qualificata, si prega di caricare sul sito la scansione dei documenti con firma autografa (in formato pdf) e di inviare gli stessi per posta ordinaria in originale a: Biomedia - Segreteria INNSIN, via Libero Temolo 4, 20126 MIlano

<br />
Previa autorizzazione da parte della segreteria INNSIN (<a href="mailto:innsin@biomedia.net">innsin@biomedia.net</a>) il Centro potrà inserire le schede pazienti accedendo al sito con le credenziali ricevute via mail.
<br />
Il Centro, in quanto titolare del trattamento dei dati, è responsabile della nomina dei soggetti autorizzati al trattamento e inserimento dei dati nella piattaforma INNSIN.
<br /><br />
<div class="title_h1 yo-color-primary" style="margin-top:30px;">MODULI DA SCARICARE, COMPILARE, FIRMARE DIGITALMENTE E UPLOADARE SUL SITO IN FORMATO p7m.</div>

<div class="row pad" style="margin-top:20px;">
  <div class="col s1 yo-align-right"><a  href="/network/documenti/innsin-accordo.pdf" style="" target="_blank"><i class="material-icons">cloud_download</i></a></div>
  <div class="col s11" style="line-height:26px;">Accordo di collaborazione scientifica tra SIN e il centro, titolare del trattamento dei dati </div>
</div>
<!--
  <div class="row pad" style="margin-top:20px;">
  <div class="col s1 yo-align-right"><a  href="#" style="" target="_blank"><i class="material-icons">cloud_download</i></a></div>
  <div class="col s11" style="line-height:26px;">Contratto di nomina a responsabile del trattamento dei dati personali </div>
</div>
-->
<div class="row pad" style="margin-top:20px;margin-bottom:30px;">
  <div class="col s1 yo-align-right"><a  href="/network/documenti/innsin-nomina.docx" style="" target="_blank"><i class="material-icons">cloud_download</i></a></div>
  <div class="col s11" style="line-height:26px;">Atto di nomina ad amministratore di sistema </div>
</div>

Ogni Centro si impegna inoltre a fornire idonea informativa e richiesta consenso trattamento dati ai genitori dei pazienti utilizzando il modulo “INFORMATIVA PRIVACY AI SENSI DELL’ ART. 13 REGOLAMENTO EUROPEO N. 679/2016“ disponibile <a href="/network/documenti/innsin-paziente.docx" style="" target="_blank">cliccando qui</a> oppure utilizzando l’informativa del proprio Centro debitamente adattata e ad ottenere il preventivo consenso ai sensi della vigente normativa in materia di privacy (D.lgs. 196/2003 come novellato dal D.lgs. 101/2018 e Regolamento Europeo 679/2016)”. 
<br /><br />
Ogni Referente del Centro potrà decidere di creare altri Referenti dello stesso Centro abilitati alla compilazione delle schede INNSIN (ogni Referente disporrà di credenziali personali).
<br /><br />
I Centri che desiderano aderire al VON sono invitati a mettersi in comunicazione con Daniela Turoli (<a href="mailto:d.turoli@ neonatalnet.org">d.turoli@ neonatalnet.org</a>).


      </div>
      
   


      <div class="title_h1 yo-color-primary" style="margin-top:30px;">UPLOAD DOCUMENTI FIRMATI</div>
      Ricordiamo che la grandezza massima dei files è di 2 megabytes.
      <div class="row pad" style="margin-top:20px;">

         <div class="col s12 m6">
            <div class="col s4"><label for="allegato" class="el-form-item__label" style="width:100% !important">Accordo di collaborazione</label></div>
            <upload class="col s8" 
            :value="$centro.profile.row.doc1" 
            v-on:change="val => $centro.profile.row.doc1=val" 
            v-on:success="doc1Success" 
            action="https://api.innsin.it/201806/vue/upload/" 
            :savedir="'www.innsin.it/upload/'+$centro.profile.row.id" 
            :previewurl="'https://www.innsin.it/upload/'+$centro.profile.row.id+'/'" 
            extensions="pdf,p7m"></upload>
         </div>
<!--
         <div class="col s12 m6 clear">
            <div class="col s4"><label for="allegato" class="el-form-item__label" style="width:100% !important">Contratto di nomina a responsabile dei dati personali</label></div>
            <upload class="col s8" 
            :value="$centro.profile.row.doc2" 
            v-on:change="val => $centro.profile.row.doc2=val" 
            v-on:success="doc1Success" 
            action="https://api.terasmm.it/201806/vue/upload/" 
            :savedir="'www.neonatologia.it/upload/'+$centro.profile.row.id" 
            :previewurl="'https://www.innsin.it/upload/'+$centro.profile.row.id+'/'"></upload>
         </div>
-->
         <div class="col s12 m6 clear">
            <div class="col s4"><label for="allegato" class="el-form-item__label" style="width:100% !important">Atto di nomina ad amministratore di sistema</label></div>
            <upload class="col s8" 
            :value="$centro.profile.row.doc3" 
            v-on:change="val => $centro.profile.row.doc3=val" 
            v-on:success="doc1Success" 
            action="https://api.innsin.it/201806/vue/upload/" 
            :savedir="'www.innsin.it/upload/'+$centro.profile.row.id" 
            :previewurl="'https://www.innsin.it/upload/'+$centro.profile.row.id+'/'" 
            extensions="pdf,p7m"></upload>
         </div>

      </div>  






      <div class="row pad" style="margin-top:20px;border-top:1px solid grey;padding-top:30px;padding-bottom:30px;">
         <div class="col s6 m4 offset-m2">
            <el-button style="width:100%;margin:10px 0;"  @click="onCancel">Esci</el-button>
         </div>
         
         <div class="col s6 m4 offset-m2">
            <el-button type="primary" @click="onSubmit" style="width:100%;background-color:#72BF44;border:none;margin:10px 0;">Invia alla segreteria</el-button>
         </div>
      </div>


   </el-form>



</div>
</template>

<script>
import emailDocumenti from './Email-documenti.vue'
import upload from './Upload.vue'
export default {
  name: 'socio-edit',
  components: {
    upload
  },
  data() {
    return {
      itm: this.$centro.profile.row, //mi serve per far si che funzioni correttamente il binding
      emailcheck:'',
      authcheck: this.$moment().format('YYYY-MM-DD'),
      checkEmail: function (rule, value, callback)  {
       console.log(this.emailcheck)
       if(typeof value !='undefined')
        if (value.toString()!=this.$centro.profile.row.email) {
          return callback(new Error('L\'indirizzo email di controllo non corrispondende all\'indirizzo email!'));
        }else{
          callback();
        }
      }
    }
  },
  created () {
    console.log("Arrivo al centro-profile.vue")
    this.$teras.pageTitle = (this.$centro.profile.row.id=='') ? 'Nuova Attività' : 'Modifica Attività: '+this.$centro.profile.row.id

    console.log(this.$centro.profile.row)
  },
  beforeDestroy () {
    clearInterval(this.minInterval)
  },
  methods: {
    doc1Success() {
      //this.doUpdate()
      this.$notify.success({type: 'info',message: 'File importato correttamente', duration:5000}) 

      

        
    }
    ,onCancel() {
        //this.$router.go(-1)
        this.$teras.event.emit('logout')
    },
    onSubmit() {
      this.$refs.formBasic.validate(async (valid) => {
        if (valid) {
          //console.log(JSON.parse(this.$centro.profile.row.doc1)[0].url)

          if(this.$centro.profile.row.doc1=='' || JSON.parse(this.$centro.profile.row.doc1)[0].url == ''){
            this.$notify.error({
              title: 'Errore',
              message: 'Devi caricare il documento "Accordo di collaborazione" prima di poter procedere!'
            });
          /*
          }else if(this.$centro.profile.row.doc2=='' || JSON.parse(this.$centro.profile.row.doc1)[0].url == ''){
            this.$notify.error({
              title: 'Errore',
              message: 'Devi caricare il documento 2 prima di poter procedere!'
            });
          */
          }else if(this.$centro.profile.row.doc3=='' || JSON.parse(this.$centro.profile.row.doc3)[0].url == ''){
            this.$notify.error({
              title: 'Errore',
              message: 'Devi caricare il documento "Atto di nomina ad amministratore di sistema" prima di poter procedere!'
            });
          }else{
            this.Save()
          }
        } else {
          return false;
        }
      });
    }
    ,emailDoc(){
      var html = this.$teras.renderVue(emailDocumenti,{contatto:this.$teras.utente})
      this.$axios.email({from:'innsin@biomedia.net',oggetto:'Ricezione documenti per partecipazione al progetto INNSIN',to:this.$teras.utente.email,body:html}).then((data) => {
        console.log("Email documenti inviata")
      }).catch((error) => {
        console.log("Errore nell'invio della email documenti")
        console.log(error)
      })

      this.$axios.email({from:'innsin@biomedia.net',oggetto:'Ricezione documenti per partecipazione al progetto INNSIN',to:'innsin@biomedia.net,mirko@terasmm.it',body:html}).then((data) => {
        console.log("Email documenti inviata")
      }).catch((error) => {
        console.log("Errore nell'invio della email documenti")
        console.log(error)
      })
    }
    ,Save(){
      this.$centro.profile.row.step = 3
      
      this.$centro.profile.save().then(data => {
        this.emailDoc()
        this.$router.push('/centro-inapprovazione/')
      })
      
      
    }

  },
  computed: {
    rules:function() {
      var rulesNow = {
        nome: [
          { required: true, message: 'Il nome del centro è obbligatorio', trigger: 'blur' }
        ],
        dircognome: [
          { required: true, message: 'Il cognome del direttore è obbligatorio', trigger: 'blur'  }
        ],
        dirnome: [
          { required: true, message: 'Il nome del direttore è obbligatorio', trigger: 'blur' }
        ],
        dircellulare: [
          { required: true, message: 'Il cellulare del direttore è obbligatorio'}
        ],
        emailchecks: [
          { required: true, message: 'L\'indirizzo email di controllo è obbligatorio'}
        ],     
        diremail: [
          { required: true, message: 'L\'indirizzo email del direttore è obbligatorio'},
          { type: 'email', message: 'Inserire un indirizzo email del direttore corretto', trigger: 'blur,change' }
        ]
        
      }
      return rulesNow
    }
  }
}
</script>
<style>
.el-upload{
  display:block !important;
}.el-upload-dragger{
  height:100px !important;
  width:100% !important;
}
</style>